import nls from '../es/CardDetails.js';
export default {
  ...nls,
  'You will receive your card, cover and annex of commissions in a maximum of 5 business days at your registered address. Once you use your card, these documents will be understood as accepted.': 'Recibirá su tarjeta, carátula y anexo de comisiones en un máximo de 5 días hábiles en su domicilio registrado. Una vez que utilices su tarjeta, dichos documentos se entenderán como aceptados.',
};
